class DialogMessageModel {
    title = ''
    message = ''
    status = false
}

export default DialogMessageModel